var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lang"},[_c('div',[_c('span',{class:{ selected: _vm.selected == 'fa' },on:{"click":function($event){return _vm.changeLocale(0)}}},[_vm._v("FA")]),_vm._v("\n    /\n    "),_c('span',{class:{ selected: _vm.selected == 'en' },on:{"click":function($event){return _vm.changeLocale(1)}}},[_vm._v("EN")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }